import { render, staticRenderFns } from "./ChangeCustomerModal.vue?vue&type=template&id=84129d32&"
import script from "./ChangeCustomerModal.vue?vue&type=script&lang=js&"
export * from "./ChangeCustomerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports